import {LoginView, SignupView, PwdResetView} from './api/auth-service'
import {SeatMapView, AdminView} from './views'

const
    routes = {
        health: '/health',
        login: '/login',
        signUp: '/signup',
        reset: '/reset',
        admin: '/admin',
        seatMap: '/'
    },
    router = {
        [routes.health]: () => () => <h3>The App is Healthy</h3>,
        [routes.login]: () => () => <LoginView/>,
        [routes.signUp]: () => () => <SignupView/>,
        [routes.reset]: () => () => <PwdResetView/>,
        [routes.seatMap]: () => (isOps) => <SeatMapView isOps={isOps}/>,
        [routes.admin]: () => (isOps) => <AdminView isOps={isOps}/>
    }

export {router as default, routes}
